<div class="verified-by-norse">
  <div 
    class="verified-by-norse__wrapper"
    (click)="onInfoClick()"
  >
    <div class="verified-by-norse__icon">
      <i class="fa-regular fa-shield-check"></i>
    </div>
    <div class="verified-by-norse__title"
      [innerHTML]="title | safeHtml: SanitizerValueType.HTML"
    ></div>
    <div class="verified-by-norse__logo">
      <img src="https://assets.flynorse.com/static/site/norse-name-white.svg" alt="Norse" />
    </div>
    <div class="verified-by-norse__info">
      <button
        appOnTap
        type="button"
        class="btn btn-link btn-white in-text"
        triggers="focus"
        placement="auto"
      >
        <i class="fa-regular fa-circle-info"></i>
      </button>
    </div>
  </div>
</div>
